import React from 'react';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import ListResources from '../../components/content/list-resources.component';

const ContentResourcesView = () => {
  const pageTitle = PAGE_TITLE_LIST.CONTENT_RESOURCES;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListResources />
    </AppLayout>
  );
};

export default ContentResourcesView;
